export const parseOptionalNumber = (value) => {
  const parsedValue = Number.parseFloat(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const getInsuranceCoveragePerAppointment = (insuranceOption = {}) => {
  const safeInsuranceOption = insuranceOption || {};
  const referralDetails = safeInsuranceOption.referralDetails || {};
  const directCoverage = parseOptionalNumber(
    referralDetails.max_coverage_per_appointment
    ?? safeInsuranceOption.maxCoveragePerAppointment
    ?? safeInsuranceOption.referralMaxCoveragePerAppointment
  );
  if (directCoverage != null && directCoverage > 0) {
    return directCoverage;
  }

  const approvedAmount = parseOptionalNumber(
    referralDetails.approved_amount
    ?? safeInsuranceOption.approvedAmount
    ?? safeInsuranceOption.totalCostAmount
  );
  const approvedTreatments = Number.parseInt(
    referralDetails.approved_treatments
    ?? safeInsuranceOption.approvedTreatments
    ?? safeInsuranceOption.referralApprovedTreatments,
    10
  );

  if (approvedAmount != null && approvedTreatments > 0) {
    return approvedAmount / approvedTreatments;
  }

  return null;
};

export const hasInsuranceSplitBilling = (bookedPrice, coveragePerAppointment) => {
  const appointmentPrice = parseOptionalNumber(bookedPrice);
  return Boolean(
    coveragePerAppointment != null
    && appointmentPrice != null
    && appointmentPrice > coveragePerAppointment
  );
};

export const calculateSplitBillingPatientAmount = ({
  bookingMode = 'patient',
  selectedPayer = 'patient',
  bookedPrice,
  coveragePerAppointment,
  invoicePatientAmount = null,
}) => {
  if (bookingMode !== 'patient' || selectedPayer === 'patient' || !hasInsuranceSplitBilling(bookedPrice, coveragePerAppointment)) {
    return null;
  }

  const parsedInvoicePatientAmount = parseOptionalNumber(invoicePatientAmount);
  if (parsedInvoicePatientAmount != null && parsedInvoicePatientAmount > 0) {
    return parsedInvoicePatientAmount;
  }

  const appointmentPrice = parseOptionalNumber(bookedPrice);
  if (appointmentPrice != null && coveragePerAppointment != null) {
    return Math.max(appointmentPrice - coveragePerAppointment, 0);
  }

  return null;
};